import React from "react";

import { Element } from "@craftjs/core";
import quote from "assets/quote.png";
import { Box, Image } from "components/ui";
import { PageText } from "./PageText";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { Dimensions } from "react-native";

export const TestimonialPanelContent = ({ ...props }) => {
	return <Box flex={1}>{props.children}</Box>;
};
export const TestimonialPanelAuthor = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};

export const PageTestimonialPanel = ({ ...props }) => {
	let isMobile = useIsMobile();
	const { width } = Dimensions.get("window");
	return (
		<Box paddingRight={32} style={{ height: "100%" }}>
			<Box
				borderRadius={12}
				borderColor="$primarylightblue"
				padding={60}
				width={"$full"}
				backgroundColor="white"
				borderWidth={2}
				display="flex"
				flexDirection="column"
				justifyContent="space-between"
				style={{ height: "100%" }}
				{...props}
			>
				<Box>
					<Image source={quote} style={{ width: 35, height: 31, marginBottom: 24 }} />
					<Element id="testimonial-text" is={TestimonialPanelContent}>
						<PageText
							text="“Lorem ipsum dolor sit amet consectetur. Etiam amet elementum tristique dignissim et leo fermentum. Amet arcu amet nam tortor justo nisi amet leo.”"
							fontSize={16}
							data-cy="slider-title"
							numberOfLines={5}
							ellipsizeMode="tail"
						/>
					</Element>
				</Box>
				<Element canvas id="author-name" is={TestimonialPanelAuthor}>
					<PageText text="Author Name" fontSize={20} data-cy="slider-title" />
				</Element>
			</Box>
		</Box>
	);
};
